import { useContext, useEffect, useMemo } from 'react';
import { useTimeout } from 'usehooks-ts';

import { ModalContext } from '@/components/Modals/Modal/config';
import { changeVipStatus } from '@/redux/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { Storage } from '../lib/storage';
import { calcSecondsToDate } from '../lib/time';

const useVipStatusHandler = (): void => {
  const { openModal } = useContext(ModalContext);
  const validUntil = useAppSelector((state) => state.user.vip?.validUntil);
  const dispatch = useAppDispatch();

  const msUntilExpiry = useMemo(() => {
    if (!validUntil) return null;

    const secondsLeft = calcSecondsToDate(validUntil);
    const ms = secondsLeft * 1000;

    return ms > 86400000 ? null : ms;
  }, [validUntil]);

  useEffect(() => {
    const checkStatus = async (): Promise<void> => {
      if (!!validUntil && msUntilExpiry !== null && msUntilExpiry <= 0) {
        const lastTimeWhenVipEndedWithContinuation = await Storage.getItem(
          'last-time-when-vip-ended-with-modal',
        );
        const lastRecordNotEqual =
          !!lastTimeWhenVipEndedWithContinuation &&
          lastTimeWhenVipEndedWithContinuation !== validUntil;

        if (!lastTimeWhenVipEndedWithContinuation || lastRecordNotEqual) {
          openModal({
            renderKind: 'selectVipPrice',
            props: { type: 'endPeriod' },
          });
          Storage.setItem<string>(
            'last-time-when-vip-ended-with-modal',
            validUntil as string,
          );
        }
      }
    };

    checkStatus();
  }, [validUntil, msUntilExpiry]);

  useTimeout(() => {
    openModal({ renderKind: 'selectVipPrice', props: { type: 'endPeriod' } });
    dispatch(changeVipStatus(false));
    Storage.setItem<string>(
      'last-time-when-vip-ended-with-modal',
      validUntil as string,
    );
  }, msUntilExpiry);
};

export { useVipStatusHandler };
